import React from "react"

import { Badge } from "@coval/ui"

export type VersionChangeType = "save" | "revert"

/**
 * Save/Revert pill for a version-history row. A revert version is highlighted
 * (info) to distinguish "rolled back to an older state" from a normal save.
 */
export const ChangeTypeBadge: React.FC<{ changeType: VersionChangeType }> = ({
  changeType,
}) => (
  <Badge variant={changeType === "revert" ? "info" : "default"} size="status">
    {changeType === "revert" ? "Revert" : "Save"}
  </Badge>
)
